import BookConfig from './BookConfig';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import NumberField from '../components/NumberField';
import Slide from '@material-ui/core/Slide';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import map from 'lodash/map'
import max from 'lodash/max'
import pluralize from '../util/pluralize'


const styles = theme => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }
});


class BookSelection extends React.Component {

  state = {}


  handleClickOpen = (book) => {
    // When reviewing a book, always start at the first step
    if (book.isComplete) this.props.data.bookConfigStep = 0
    this.props.actions.openBookConfig(book.id)
  };

  handleClose = () => {
    this.props.actions.closeBookConfig()
  };

  render = () => {
    const {classes, data, actions, smallScreen} = this.props
    const {currentBook, bookConfigStep} = data
    const pricingMode = data.pricingMode
    const maxLicenseCount = max(map(data.orders, 'numberOfLicenses'))

    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Pick Your Books
        </Typography>

        <Grid container spacing={8}>
          {
            data.orders.map(order => (
              <React.Fragment key={order.title}>
                <Grid item xs={12} sm={1}>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <FormControlLabel
                    label={`${order.title} Guides`}
                    control={
                      <Checkbox
                        checked={order.bookSelected}
                        onChange={ e => actions.setBookSelected(order, e.target.checked) }
                        value={`order-${order.id}-selected`}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={6} sm={5}>
                  {
                    order.bookSelected
                    ? <Button
                        variant={(!order.bookSelected || order.isComplete) ? "outlined" : "contained"}
                        onClick={() => this.handleClickOpen(order)}
                        fullWidth={true}
                        color={order.isComplete ? "default" : "primary"}
                      >
                        {order.isComplete ? "Review" : "Configure"}
                      </Button>
                    : null
                  }
                </Grid>
                <Grid item xs={12} sm={1}>
                </Grid>
              </React.Fragment>
            ))
          }
        </Grid>

        {
          (pricingMode === 'Safe')
          ? <div>
              <br/>
              <br/>
              <Divider variant="middle" />
              <br/>
              <Grid container spacing={16}>
                <Grid item xs={12} sm={1} style={{paddingTop:0,paddingBottom:0}}></Grid>
                <Grid item xs={12} sm={6}>
                  <Typography style={{paddingTop:28}}>
                    How many techs will use these books?
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <FormControlLabel
                    style={{marginTop:12, marginLeft:4}}
                    label={pluralize(maxLicenseCount, 'Technician')}
                    control={
                      <NumberField
                        min={1}
                        value={maxLicenseCount}
                        onChange={newVal => actions.updateNumberOfLicensesOnAllBooks(newVal)}
                        />
                    }
                  />
                </Grid>
              </Grid>
              <br/>
              <br/>
              <Divider variant="middle" />
            </div>
          : null
        }

        <br/>
        <Dialog
          fullScreen={smallScreen}
          fullWidth={true}
          maxWidth={smallScreen ? null : "md"}
          open={!!currentBook}
          TransitionComponent={Slide}
          TransitionProps={{direction: 'up'}}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title"  className={classes.dialogTitle} disableTypography>
            <Typography variant="h5"> {currentBook && currentBook.title} Book </Typography>
            <IconButton onClick={this.handleClose}> <CloseIcon /> </IconButton>
          </DialogTitle>
          <DialogContent>
            <BookConfig
              smallScreen={smallScreen}
              order={currentBook}
              actions={actions}
              onClose={this.handleClose}
              bookConfigStep={bookConfigStep}
              pricingMode={pricingMode}
            />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(BookSelection);
